console.log("hero_slider");
$('.hero').slick({
    dots: false,
    infinite: true,
    arrows: false,
    pauseOnHover: false,
    fade: true,
    autoplay: true,
    autoplaySpeed: 4000,
    adaptiveHeight: false
});
$(".hero-slide__nav").find(".dot").on('click', function(){
    slide_index = $(this).data('index');
    $('.hero').slick("slickGoTo", slide_index - 1);
});
